/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MemberProfileDto { 
    emailAddress?: string | null;
    countryCode?: string | null;
    phoneNumber?: string | null;
    fullName?: string | null;
    dob?: string | null;
    currentResidenceAddress?: string | null;
    lastResidenceAddress?: string | null;
    isMarried?: boolean | null;
    spouseName?: string | null;
    currentPlaceOfEmployment?: string | null;
    lastPlaceOfEmployment?: string | null;
    isLastPlaceOfEmploymentIsSameAsOfCurrent?: boolean | null;
    isLastResidenceAddressIsSameAsOfCurrent?: boolean | null;
    readonly surname?: string | null;
    readonly middleName?: string | null;
    readonly name?: string | null;
    isActive?: boolean;
}

